import { LineTittle } from "../../../components/Common/CommonStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import Text from "../../../components/Common/Text";
import PropTypes from "prop-types";

const Titulo = ({ titulo }) => {
  const empresa = useEmpresa();

  return (
    <Section flexDirection={"column"} align={"center"}>
      <Text
        color={empresa?.COLOR_SECUNDARIO}
        weight={"bold"}
        size={"16px"}
        textAlign={"center"}
      >
        {titulo}
      </Text>
      <LineTittle maxWidth={"95%"} />
    </Section>
  );
};

Titulo.propTypes = {
  titulo: PropTypes.string.isRequired
};

export default Titulo;
